import { useMutation, useQueryClient } from "@tanstack/react-query";
import { makeApiRequest } from "../../utils";
import { VENDOR_REVENDORIZATIONS_QUERY_KEY } from "../../../constants/queryKeys";

export const useCreateVendorRules = () => {
  const queryClient = useQueryClient();

  const createRules = useMutation({
    mutationFn: async ({ rules }) => {
      return makeApiRequest({
        endpoint: "/api/vendor-revendorizations/create-rules",
        method: "POST",
        body: { rules },
        json: true
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries([VENDOR_REVENDORIZATIONS_QUERY_KEY]);
    }
  });

  return {
    createRules
  };
};
